import React, { useEffect, useState } from "react";
import "./GarudaSenaDetails.css";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";
import ScrollingBanner from "../Home/ScrollingBanner";
import { Link } from "react-router-dom";


// const programs = [
//   {
//     title: "NNNVK – Divyangjan Divya Darshan",
//     icon: "🙏",
//     desc: "A signature initiative of the Trust enabling free darshan for Divyangjan devotees. Bridging the gap between Tirumala Temple and the differently-abled. A mission to ensure every devotee experiences divine grace without barriers."
//   },
//   {
//     title: "Shatamanam Bhavathi (Divyangjan Marriage Program)",
//     icon: "💍",
//     desc: "A divine initiative organizing free marriages for Divyangjan couples. Promotes equality, love, and dignity in their sacred union. Blessing every couple with a new beginning under Lord Sri Venkateswara Swamy’s grace at Tirumala according to TTD rules. Food, accommodation, darshanam, and prasadam are provided by the Trust."
//   },
//   {
//     title: "Shashtipoorthi (For Volunteers above 60 Years)",
//     icon: "🎉",
//     desc: "A special program to honor and bless our volunteers who have reached the sacred milestone of sixty years, celebrating their wisdom, selfless service, and spiritual journey. This heartfelt tribute recognizes their lifelong dedication to humanity. The ceremony will be conducted at Tirumala, with all arrangements organized by the Trust"
//   },
//   {
//     title: "Pitru Tarpanam (For Volunteers’ Families)",
//     icon: "🕊️",
//     desc: "A sacred ritual program to honor and offer prayers for ancestors. Volunteers perform spiritual duties for their departed loved ones at Kapilateertham, Tirupati — promoting gratitude, peace, and family harmony."
//   },
//   {
//     title: "Garuda Prerana (Personality Development)",
//     icon: "🦅",
//     desc: "A transformative program that nurtures confidence, communication and leadership for volunteers and devotees. It aims to build strong personalities rooted in values, devotion, and service, empowering everyone to lead with purpose and compassion."
//   },
//   {
//     title: "Garudaananda Maargam (Stress-Free Living)",
//     icon: "🌿",
//     desc: "A spiritual and psychological wellness initiative promoting peace of mind and balance. Combines ancient wisdom with modern stress-management techniques, helping devotees and volunteers live joyfully, free from anxiety and inner turmoil."
//   },
//   {
//     title: "Garuda Exam Warriors (For Students)",
//     icon: "📘",
//     desc: "A motivational program to help students overcome exam fear through focus and faith. It offers guidance, mental preparation and positive thinking techniques, encouraging students to transform stress into strength and success."
//   },
//   {
//     title: "Garuda Aarogya Sethu (Health Awareness)",
//     icon: "💊",
//     desc: "A health and wellness awareness drive for all volunteers and devotees. Covers preventive health care, fitness and holistic living practices. A step towards a healthy body and a divine spirit."
//   },
//   {
//     title: "Garuda Careers (Job Assistance)",
//     icon: "💼",
//     desc: "A support initiative to assist and empower unemployed youth and volunteers. Includes job guidance and career counseling sessions. Helping individuals achieve professional growth with confidence and dignity."
//   },
//   {
//     title: "Garuda Yoga Shakti (Yoga Program)",
//     icon: "🧘‍♂️",
//     desc: "A holistic yoga and meditation program for physical, mental, and spiritual well-being. Inspired by the discipline of Garuda and the devotion to Lord Venkateswara. Bringing balance, flexibility and divine energy into daily life"
//   },
//   {
//     title: "Garuda Kala Vedika (Cultural Programs)",
//     icon: "🎭",
//     desc: "A platform to preserve and promote Indian art, music and devotional culture. Encourages volunteers and devotees to express bhakti through creative performances. Celebrating devotion through cultural unity and artistic excellence."
//   },
//   {
//     title: "Garuda NRI Forum (For NRI Volunteers)",
//     icon: "🌏",
//     desc: "A global volunteer network connecting devotees across borders. Assisting NRI devotees  for Tirumala Darshan and promoting Sanatana dharma in various countries. Spiritual awareness for NRI devotees. Uniting the global Garuda Sena family under one divine mission."
//   },
//   {
//     title: "Garuda Pournami (Pournami Darshanam)",
//     icon: "🌕",
//     desc: "A sacred full-moon darshan program dedicated to fostering peace, devotion, and divine energy. Each month, selected Garuda Sena Volunteers will take part in this blessed initiative. The program will be organized in phases, ensuring that every devotee and volunteer receives the divine opportunity for Pournami Darshan in an orderly manner."
//   },
//   {
//     title: "Garuda Nyaya Seva (Legal Awareness Program)",
//     icon: "⚖️",
//     desc: "An initiative to educate devotees and volunteers about their legal rights. Includes awareness sessions, counseling, and free legal guidance. Ensuring justice, protection, and empowerment through knowledge."
//   },
//   {
//     title: "Garuda Go Seva (Holy Cow Worship)",
//     icon: "🐄",
//     desc: "A divine initiative dedicated to the worship and care of the sacred cow, symbol of dharma and abundance. Volunteers and devotees participate in go-puja at Tirupati. Through Go-Seva, devotees express gratitude, compassion, and service to Gau Mata, the embodiment of purity and prosperity."
//   },
// ];

const GarudaSenaDetails = () => {
const [programs, setPrograms] = useState([]);
  const [activeProgram, setActiveProgram] = useState(null);
    // const [activeProgram, setActiveProgram] = useState(null);

 // ✅ Fetch Programs from API
  useEffect(() => {
    fetch("https://api.garudasena.org/api/programs")
      .then((res) => res.json())
      .then((data) => setPrograms(data))
      .catch((err) => console.error("Error loading programs:", err));
  }, []);


  return (
    <>
      <Navbar />
    <section id="garuda-sena-details">
      <div className="details-container">
        <h1>Garuda Sena Volunteers – SASCCT</h1>
        <p className="subtitle">
          (Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust)
        </p>
        <h3 className="quote">
          “Service to Devotees is Service to Lord Sri Venkateshwara Swamy”
        </h3>

        <div className="details-content">
          <h2>1. Eligibility</h2>
          <p>
            Open to all individuals aged 18–60 years who are physically fit and
            willing to serve. Members must uphold the values of service,
            devotion, and discipline.
          </p>

          <h2>2. Membership Donation</h2>
          <ul>
            <li>Membership donation ₹1008/-.</li>
            {/* <li>Membership valid for the lifetime of the individual.</li> */}
            <li>
              Donation used solely for charitable and spiritual activities of the
              Trust.
            </li>
          </ul>

          <h2>3. Volunteer Service</h2>
          <p>
            As a proud member of the Garuda Sena Volunteers, you will play a
            vital role in serving devotees with dedication, humility, and
            devotion. Your seva will include:
          </p>

          <ul>
            <li>
              <strong>Assisting Divyangjan Devotees –</strong> Actively support
              differently-abled devotees during Divyangjan Divya Darshan (DDD)
              programs, ensuring comfort, dignity, and smooth darshan.
            </li>
            <li>
              <strong>Participation in Special Trust Programs –</strong> Be part
              of sacred events under TTD guidelines:
              <ul>
                <li>
                  <em>Divyangjan Shatamanambhavathi (Kalyanam)</em> – marriages
                  for unwed Divyangjan couples.
                </li>
                <li>
                  <em>Shashtipoorthi Seva –</em> support for Garuda Sena
                  Volunteers celebrating Shashtipoorthi at Tirumala.
                </li>
                <li>
                  <em>Tarpanam Seva –</em> assist families performing Tarpanam at
                  Kapila Theertham, Tirupati.
                </li>
              </ul>
            </li>
            <li>
              <strong>Local Seva Activities –</strong> Volunteers may
              participate in:
              <ul>
                <li>🩸 Blood Donation Camps</li>
                <li>🏥 Medical & Health Camps</li>
                <li>🍛 Food Distribution Drives</li>
                <li>🌸 Spiritual Awareness & Outreach Programs</li>
              </ul>
            </li>
          </ul>

          <p className="vision">
            Through these services, Garuda Sena Volunteers embody the Trust’s vision — 
            <strong>“Faith Without Barriers – Darshan for All.”</strong>
          </p>

              <h2>4. Volunteer Programs / Benefits</h2>
<p>
  As a Garuda Sena Volunteer, you gain access to several personal development,
  service, and spiritual growth programs conducted under the guidance of
  <strong> SASCCT Trust</strong>. These include:
</p>

{/* <div className="volunteer-programs">
  <div className="program-card">🦅 <strong>Garuda Prerana</strong><br />Personality Development</div>
  <div className="program-card">🌿 <strong>Garudaananda Maargam</strong><br />Stress-Free Living</div>
  <div className="program-card">📘 <strong>Garuda Exam Warriors</strong><br />For Students Preparing for Exams</div>
  <div className="program-card">💊 <strong>Garuda Aarogya Sethu</strong><br />Health & Wellness Programs</div>
  <div className="program-card">💼 <strong>Garuda Careers</strong><br />Job Assistance & Guidance</div>
  <div className="program-card">🧘‍♂️ <strong>Garuda Yoga Shakti</strong><br />Yoga & Meditation Sessions</div>
  <div className="program-card">🎭 <strong>Garuda Kala Vedika</strong><br />Cultural & Arts Programs</div>
  <div className="program-card">🙏 <strong>NNNVK – Divyangjan Divya Darshan</strong><br />Service to Differently-Abled Devotees</div>
  <div className="program-card">💍 <strong>Shatamanam Bhavathi</strong><br />Divyangjan Marriage Seva</div>
  <div className="program-card">🎉 <strong>Shashtipoorthi Seva</strong><br />Support for Volunteers Aged 60+</div>
  <div className="program-card">🕊️ <strong>Pitru Tarpanam</strong><br />For Volunteers’ Families</div>
  <div className="program-card">🌏 <strong>Garuda NRI Forum</strong><br />Support for NRI Volunteers</div>
  <div className="program-card">🌕 <strong>Garuda Pournami</strong><br />Special Pournami Darshan Seva</div>
  <div className="program-card">⚖️ <strong>Garuda Nyaya Seva</strong><br />Legal Awareness & Support</div>
  <div className="program-card">🐄 <strong>Garuda Go Raksha</strong><br />Cow Protection & Go Seva</div>
</div> */}

 <div className="volunteer-programs">
              {programs.map((p) => (
                <div key={p.id} className="program-card">
                  
                  {/* Program Image */}
                  {p.image && (
                    <img
                      src={p.image}
                      alt={p.program_name}
                      className="program-img"
                    />
                  )}

                  <strong>{p.program_name}</strong>

                  <button
                    className="know-more-btn"
                    onClick={() => setActiveProgram(p)}
                  >
                    Know More →
                  </button>

                  {/* {p.join_us === 1 && (
                    <Link to="/enroll" className="join-btn">
                      Join Now →
                    </Link>
                  )} */}
                </div>
              ))}
            </div>

          <h2>5. Code of Conduct</h2>
          <ul>
            <li>
              Volunteers must act with discipline, dignity, and devotion at all
              times.
            </li>
            <li>
              Misconduct or misuse of benefits may lead to suspension or
              cancellation of membership.
            </li>
            <li>
              Volunteers represent the Trust and must not harm its reputation.
            </li>
          </ul>

          <h2>6. Rights of the Trust</h2>
          <ul>
            <li>
              Trust may modify benefits, schedules, or programs as per TTD or
              Government guidelines.
            </li>
            <li>
              Trust may accept/reject membership or refund ₹1008 upon removal.
            </li>
            <li>
              Decisions of Trust Management are final and binding.
            </li>
          </ul>

          <h2>7. Legal Disclaimer</h2>
          <p>
            Membership is voluntary, non-transferable, and not employment.
            SASCCT is not liable for accidents or unforeseen events during seva
            or travel. No financial returns or refunds are promised. By
            enrolling, volunteers accept all terms and disclaimers.
          </p>

          <h2>8. How to Enroll</h2>
          <ol>
            <li>Fill the online registration form (via Trust’s WhatsApp/Website).</li>
            <li>Pay ₹1008 membership donation.</li>
            <li>Join the Garuda Sena Volunteer WhatsApp group.</li>
            <li>Receive your Digital Certificate of Membership.</li>
          </ol>

      
         {/* ✅ Enroll Now Button */}
            <div className="enroll-btn-container">
            <Link to='/enroll'  className="enroll-btn" >
                ENROLL NOW
              </Link> 
            </div>
        </div>
      </div>
    </section>
       {/* ✅ Modal */}
{activeProgram && (
        <div className="program-modal" onClick={() => setActiveProgram(null)}>
          <div
            className="program-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-modal"
              onClick={() => setActiveProgram(null)}
            >
              ✕
            </button>

            {/* Header */}
          <div className="modal-header-flex">
  {activeProgram.image && (
    <img
      src={activeProgram.image}
      alt={activeProgram.program_name}
      className="modal-header-img"
    />
  )}

  <h2 className="modal-header-title">{activeProgram.program_name}</h2>
</div>


            {/* Description */}
            <p>{activeProgram.description}</p>

            {/* Optional Contact Person */}
            {activeProgram.contact_person && (
              <p className="contact-person">
                <strong>Contact Person:</strong> {activeProgram.contact_person}
              </p>
            )}

            {/* Join Button */}
            {activeProgram.join_us === 1 && (
              <Link to="/enroll" className="modal-join-btn">
                Join This Program →
              </Link>
            )}
          </div>
        </div>
      )}

    <ScrollingBanner/>
    <Footer/>
        </>
  );
};

export default GarudaSenaDetails;
